export default class ResponsiveBackgroundImage {
    constructor() {
        this.selector = '*[data-mobile-background-image]';
        this.init();
    }

    init() {
        var self = this,
            $elements = $( self.selector ),
            viewportWidth = $( window ).width();

        $elements.each( function() {
            var $element = $( this ),
                mobileBackgroundImageUrl = $element.attr( 'data-mobile-background-image' );

            if ( viewportWidth <= 768 ) {
                $element.css( 'background-image', 'url("' + mobileBackgroundImageUrl + '")' );
            }
        } );
    }
}